import { render, staticRenderFns } from "./dataCarousel.vue?vue&type=template&id=3d7ed340&"
import script from "./dataCarousel.vue?vue&type=script&lang=js&"
export * from "./dataCarousel.vue?vue&type=script&lang=js&"
import style0 from "./dataCarousel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports